import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { POST_SERVICE_USER_SIGNUP_URL, PUT_USERS_PROFILE_VIDEO_URL, ADMIN_AUTH_TOKEN } from "../../env";
import {
  postRecords,
  isSuccess,
  isFail,
  catchAsync,
  updateFormFields,
  toastSuccessMessages,
  toastErrorMessages,
} from "../../helper/helper";
import Input from "../../components/forms-fields/Input";
import TextArea from "../../components/forms-fields/TextArea";
import { useFormik } from "formik";
import { addSUSignUp } from "../../schemas";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";

function InformationForm() {
  const [profileVideoUrl, setProfileVideoUrl] = useState(null);
  const [videoSizeError, setVideoSizeError] = useState(false);
  const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);
  const [formData, setFormData] = useState({
    profilePic: "/uploads/dp/default.png",
    name: "",
    email: "",
    password: "123456",
    phoneNumber: "",
    deviceId: "123",
    version: "0",
    role: "serviceuser",
    password: "123456",
    userModelName: "serviceUser",
    active: true,
    is_verified: true,
    approved: true,
    fcm_tokens: {
      token:
        "fY6_DGfGQ06OW4BUVEsEwG:APA91bGUFza2uhaaR0miN2jtY0ut7RuA5ObleZvqv2X8KLOBgksmDmgc9sHDdea-DBvHmz1aUwX1uhkysk92x50WQCLHPDD1VwGX5ybKhUwVdq4aBfI24vhXqMB-FksWXEZwzDAi9BA_",
      deviceType: "android",
    },
    location: {
      type: "Point",
      coordinates: [74.28911289869138, 31.624848273644956],
    },
    //service user fields
    suLastName: "",
    referenceId: "",
    suFirstMiddleName: "",
    suPreferredName: "",
    suSsn: "",
    suSex: "Male",
    suTitle: "Mr",
    suDOB: "",
    suAge: "",
    suReferredBY: "",
    // suFamilyHead: "",
    suAddress1: "",
    suAddress2: "",
    suCity: "",
    suState: "",
    suZip: "",
    suCountry: "",
    suFirstVisitDate: "",
    suLastVisitDate: "",
    providerName: "",
    suHomePhone: "",
    // suWorkPhone: "",
    suMobileHomeNo: "",
    // suMobileWorkNo: "",
    suEmailHome: "",
    suEmailWork: "",
    // suPrefHomeNo: "",
    // suPrefWorkNo: "",
    suEmergencyContact: "",
    seMedicalAlert: "",
    suNote: "",
    profile_video_url: "",
    diagnosises: [
      {
        diagnosisText: "some text",
        diagnosisDate: "2023-11-01 00:05:00",
        diagnosisBy: "Dr. Michael Taylor",
        isCurrentDiagnosis: true,
      },
    ],
    aboutPatient: {
      aboutText: "About",
      aboutDate: "2023-11-01 00:00:00",
      aboutBy: "John Smith",
    },
    shifts: [],
    serviceUserMedications: [],
    homeVisitSignOut: [],
    nokName: "",
    nokRelationship: "",
    nokAddress: "",
    nokEmail: "",
    nokMobile: "",
  });

  const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } =
    useFormik({
      initialValues: formData,
      validationSchema: addSUSignUp,


      onSubmit: catchAsync(async (req, res) => {
        try {
          const result = await postRecords(
            POST_SERVICE_USER_SIGNUP_URL,
            values
          );

          if (result?.status === isSuccess) {
            console.log("🚀 ~ InformationForm ~ result:", result)
            toastSuccessMessages(
              toast?.success,
              result?.message,
              "/service-users",
              // "",
              2000,
              2000
            );
          } else if (result?.status === isFail) {
            toastErrorMessages(toast?.error, result?.message, "", 3000);
          }
        } catch (error) { }
      }),
    });

  // console.log("🚀 ~ InformationForm ~ values:", values)
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let updatedData = { ...formData };
    let trimmedValue = value.trim();

    if (name === "suFirstMiddleName") {
      updatedData = {
        ...updatedData,
        name: trimmedValue,
        [name]: trimmedValue,
      };
    }
    if (name === "suEmailHome") {
      updatedData = {
        ...updatedData,
        email: trimmedValue,
        [name]: trimmedValue,
      };
    } else {
      updatedData = {
        ...updatedData,
        [name]: trimmedValue,
      };
    }

    setFormData(updatedData);
    handleChange(e);
    handleBlur(e);
  };

  // Function to handle the profile picture
  const handleProfilePicChange = (e) => {
    e?.preventDefault();
    updateFormFields(e, setFormData, "image");
  };


  const handleVideoUpload = async (e) => {
    setIsSubmitButtonClicked(true);
    try {
      const file = e.target.files[0];
      const fileType = file.type;
      const fileSize = file.size;
      // console.log("🚀 ~ handleVideoUpload ~ fileSize:", fileSize)
      // Validate file size (5MB = 1,048,576 bytes)
      if (fileSize > 5 * 1024 * 1024) {
        alert('File size exceeds 5MB');
        setVideoSizeError(true)
        setIsSubmitButtonClicked(false);
        return;
      }

      // Validate file type
      if (
        fileType === 'video/mp4' ||
        fileType === 'video/avi' ||
        fileType === 'video/mov' ||
        fileType === 'video/wmv' ||
        fileType === 'video/flv' ||
        fileType === 'video/webm' ||
        fileType === 'video/mkv' ||
        fileType === 'video/quicktime' // Add additional video formats as needed
      ) {
        const fileData = new FormData();
        fileData.append('attachements', file);
        const apiResponse = await fetch(PUT_USERS_PROFILE_VIDEO_URL, {
          method: "POST",
          body: fileData,
          headers: {
            Authorization: `Bearer ${ADMIN_AUTH_TOKEN}`,
          },
        });
        const resultResponse = await apiResponse.json();
        // setUploadedFilePath(resultResponse?.data[0]?.fileNameInDirectory);
        setProfileVideoUrl(resultResponse?.data[0]?.fileNameInDirectory)
        setVideoSizeError(false)
        // console.log("File uploaded successfully:", resultResponse?.data[0]?.fileNameInDirectory);
        // console.log("uploadedFilePath uploadedFilePath uploadedFilePath:", uploadedFilePath);
      } else {
        // Unsupported file format
        alert('Unsupported file format');
      }
      setIsSubmitButtonClicked(false);
    } catch (error) {
      console.error("Error uploading file:", error);
      setIsSubmitButtonClicked(false);
    }
  };
  useEffect(() => {
    // console.log("profileVideoUrl changed:", profileVideoUrl);

    setFieldValue("profile_video_url", profileVideoUrl);
    // console.log("profile_video_url changed:", values?.profile_video_url);
  }, [profileVideoUrl, setFieldValue]);

  useEffect(() => {
    // suDOB
    console.log("🚀 ~ InformationForm ~ values:", values)
  }, [values])
  return (
    <>
      <div className="youngInformationForm">
        <form onSubmit={handleSubmit}>
          {/* First Row */}
          <div className="row">
            <div className="col-md-4">
              <Input
                type="text"
                id="referenceId"
                name="referenceId"
                value={values?.referenceId}
                onChange={handleInputChange}
                onBlur={handleBlur}
                labelText="Reference ID"
                customError={
                  errors.referenceId && touched.referenceId
                }
                errorMessage={errors.referenceId}
                errorClass={
                  errors.referenceId && touched.referenceId
                }
                requiredStar={true}
              />
            </div>
          </div>
          <div className="row">

            <div className="col-md-12">
              <p><strong>Personal Information</strong></p>
            </div>
            <div className="col-md-4">
              <Input
                type="text"
                id="suFirstMiddleName"
                name="suFirstMiddleName"
                value={values?.suFirstMiddleName}
                onChange={handleInputChange}
                onBlur={handleBlur}
                labelText="First Name"
                customError={
                  errors.suFirstMiddleName && touched.suFirstMiddleName
                }
                errorMessage={errors.suFirstMiddleName}
                errorClass={
                  errors.suFirstMiddleName && touched.suFirstMiddleName
                }
                requiredStar={true}
              />
            </div>
            <div className="col-md-4">
              <Input
                type="text"
                id="suLastName"
                name="suLastName"
                value={values?.suLastName}
                onChange={handleInputChange}
                labelText="Last Name"
              />
            </div>

            <div className="col-md-4">
              <Input
                type="text"
                id="suPreferredName"
                name="suPreferredName"
                value={values?.suPreferredName}
                onChange={handleInputChange}
                labelText="Preferred Name"
              />
            </div>

            <div className="col-md-4">
              <Input
                type="text"
                id="suSsn"
                name="suSsn"
                value={values?.suSsn}
                onChange={handleInputChange}
                labelText="SSN"
              />
            </div>
            <div className="col-lg-2 col-md-4 pr-0">
              <div className="form-group div30">
                <select
                  name="suSex"
                  id="suSex"
                  value={values?.suSex}
                  onChange={handleInputChange}
                >
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
                <label htmlFor="suSex" className="floatingLabel">
                  Gender
                </label>
              </div>
            </div>
            <div className="col-lg-2 col-md-4">
              <div className="form-group div30">
                <select
                  name="suTitle"
                  id="suTitle"
                  value={values?.suTitle}
                  onChange={handleInputChange}
                >
                  <option value="Mr">Mr.</option>
                  <option value="Ms">Ms.</option>
                </select>
                <label htmlFor="suTitle" className="floatingLabel">
                  Title
                </label>
              </div>
            </div>

            <div className="col-lg-2 col-md-4 pr-0">
              <Input
                type="date"
                datePicker={true}
                name="suDOB"
                value={values?.suDOB}
                selected={
                  values?.suDOB &&
                    moment(values.suDOB, "YYYY-MM-DD").isValid()
                    ? moment(values.suDOB, "YYYY-MM-DD").toDate()
                    : null
                }
                dateFormat="YYYY-MM-DD"
                onChange={(suDOB) =>
                  setFieldValue("suDOB", moment(suDOB).format("YYYY-MM-DD"))
                }
                labelText="Date of Birth"
                placeholderText="Select Start Date"
                showYearDropdown={true}
              />

              {/* <Input
                type="date"
                id="suDOB"
                name="suDOB"
                value={values?.suDOB}
                onChange={handleInputChange}
                labelText="Date of Birth"
              /> */}
            </div>
            <div className="col-lg-2 col-md-4 pl-0">
              <Input
                type="number"
                id="suAge"
                name="suAge"
                value={values?.suAge}
                onChange={handleInputChange}
                labelText="Age"
              />
            </div>

            <div className="col-md-4 pr-0">
              <Input
                type="text"
                id="suMobileHomeNo"
                name="suMobileHomeNo"
                value={values?.suMobileHomeNo}
                onChange={handleInputChange}
                onBlur={handleBlur}
                labelText="Mobile Home No."
                customError={errors.suMobileHomeNo && touched.suMobileHomeNo}
                errorMessage={errors.suMobileHomeNo}
                errorClass={errors.suMobileHomeNo && touched.suMobileHomeNo}
                requiredStar={true}
              />
            </div>
            <div className="col-md-4">
              <Input
                type="email"
                id="suEmailHome"
                name="suEmailHome"
                value={values?.suEmailHome}
                onChange={(e) => {
                  handleInputChange(e);
                  setFieldValue("email", e.target.value);
                }}
                onBlur={handleBlur}
                labelText="Email Home"
                customError={errors.suEmailHome && touched.suEmailHome}
                errorMessage={errors.suEmailHome}
                errorClass={errors.suEmailHome && touched.suEmailHome}
                requiredStar={true}
              />
            </div>
            <div className="col-md-4">
              <Input
                type="text"
                id="suEmailWork"
                name="suEmailWork"
                value={values?.suEmailWork}
                onChange={handleInputChange}
                labelText="Email Work"
                customError={errors.suEmailWork && touched.suEmailWork}
                errorMessage={errors.suEmailWork}
                errorClass={errors.suEmailWork && touched.suEmailWork}
              />
            </div>
          </div>

          {/* Second Row Address Detail */}
          <div className="row">
            <div className="col-md-12">
              <p><strong>Address Information</strong></p>
            </div>

            <div className="col-md-4">
              <Input
                type="text"
                id="suAddress1"
                name="suAddress1"
                value={values?.suAddress1}
                onChange={handleInputChange}
                labelText="Address 1"
              />
            </div>

            <div className="col-md-4">
              <Input
                type="text"
                id="suAddress2"
                name="suAddress2"
                value={values?.suAddress2}
                onChange={handleInputChange}
                labelText="Address 2"
              />
            </div>

            <div className="col-md-4">
              <Input
                type="text"
                id="suCity"
                name="suCity"
                value={values?.suCity}
                onChange={handleInputChange}
                labelText="City"
              />
            </div>

            <div className="col-lg-4 col-md-4">
              <Input
                type="text"
                id="suState"
                name="suState"
                value={values?.suState}
                onChange={handleInputChange}
                labelText="County"
              />
            </div>

            <div className="col-lg-4 col-md-4">
              <Input
                type="text"
                id="suZip"
                name="suZip"
                value={values?.suZip}
                onChange={handleInputChange}
                labelText="Postcode"
              />
            </div>
            <div className="col-lg-4 col-md-4">
              <Input
                type="text"
                id="suCountry"
                name="suCountry"
                value={values?.suCountry}
                onChange={handleInputChange}
                labelText="Country"
              />
            </div>

          </div>
          {/* Third Row */}
          <div className="row">
            <div className="col-md-12">
              <p><strong>NOK Information</strong></p>
            </div>

            <div className="col-md-4">
              <Input
                type="text"
                id=""
                name="nokName"
                value={values?.values?.nokName}
                onChange={handleInputChange}
                onBlur={handleBlur}
                labelText="NOK Name"
                customError={
                  touched?.nokName &&
                  errors?.nokName
                }
                errorMessage={errors?.nokName}
                erroClass={
                  touched?.nokName &&
                    errors?.nokName
                    ? "validationError"
                    : ""
                }
                requiredStar={true}
              />
            </div>

            <div className="col-md-4">
              <Input
                type="text"
                id=""
                name="nokRelationship"
                value={values?.nokRelationship}
                onChange={handleInputChange}
                onBlur={handleBlur}
                labelText="NOK Relationship"
                customError={
                  touched?.nokRelationship &&
                  errors?.nokRelationship
                }
                errorMessage={errors?.nokRelationship}
                erroClass={
                  touched?.nokRelationship &&
                    errors?.nokRelationship
                    ? "validationError"
                    : ""
                }
                requiredStar={true}
              />
            </div>

            <div className="col-md-4">
              <Input
                type="text"
                id=""
                name="nokAddress"
                value={values?.nokAddress}
                onChange={handleInputChange}
                onBlur={handleBlur}
                labelText="NOK Address"
                customError={
                  touched?.nokAddress &&
                  errors?.nokAddress
                }
                errorMessage={errors?.nokAddress}
                erroClass={
                  touched?.nokAddress &&
                    errors?.nokAddress
                    ? "validationError"
                    : ""
                }
                requiredStar={true}
              />
            </div>


            <div className="col-md-4">
              <Input
                type="text"
                id=""
                name="nokEmail"
                value={values?.nokEmail}
                onChange={handleInputChange}
                onBlur={handleBlur}
                labelText="NOK Email"
                customError={
                  touched?.nokEmail &&
                  errors?.nokEmail
                }
                errorMessage={errors?.nokEmail}
                erroClass={
                  touched?.nokEmail &&
                    errors?.nokEmail
                    ? "validationError"
                    : ""
                }
                requiredStar={true}
              />
            </div>

            <div className="col-md-4">
              <Input
                type="text"
                id=""
                name="nokMobile"
                value={values?.nokMobile}
                onChange={handleInputChange}
                onBlur={handleBlur}
                labelText="NOK Mobile"
                customError={
                  touched?.nokMobile &&
                  errors?.nokMobile
                }
                errorMessage={errors?.nokMobile}
                erroClass={
                  touched?.nokMobile &&
                    errors?.nokMobile
                    ? "validationError"
                    : ""
                }
                requiredStar={true}
              />
            </div>

            {/* <div className="col-md-4">
              <div className="form-group div30">
                <select
                  name="suOtherContacts"
                  id="suOtherContacts"
                  value={values?.suOtherContacts}
                  onChange={handleInputChange}
                >
                  <option value="GP (General Practitioner)">GP (General Practitioner)</option>
                  <option value="Paediatrician">Paediatrician</option>
                  <option value="CAMHS Practitioner">CAMHS Practitioner</option>
                  <option value="Clinical Psychologist / Psychiatrist">Clinical Psychologist / Psychiatrist</option>
                  <option value="Speech and Language Therapist (SALT)">Speech and Language Therapist (SALT)</option>
                  <option value="Occupational Therapist (OT)">Occupational Therapist (OT)</option>
                  <option value="Physiotherapist">Physiotherapist</option>
                  <option value="Learning Disability Nurse">Learning Disability Nurse</option>
                  <option value="School Nurse / Community Nurse">School Nurse / Community Nurse</option>
                  <option value="Dietitian / Nutritionist">Dietitian / Nutritionist</option>
                  <option value="Allocated Social Worker">Allocated Social Worker</option>
                  <option value="Independent Reviewing Officer (IRO)">Independent Reviewing Officer (IRO)</option>
                  <option value="Personal Advisor (PA)">Personal Advisor (PA)</option>
                  <option value="Advocate / Independent Visitor">Advocate / Independent Visitor</option>
                  <option value="Family Support Worker / Early Help Worker">Family Support Worker / Early Help Worker</option>
                  <option value="Guardian (CAFCASS)">Guardian (CAFCASS)</option>
                  <option value="Other">Other</option>
                </select>
                <label htmlFor="suOtherContacts" className="floatingLabel">
                  Contact Role
                </label>
              </div>
            </div> */}

            {/* <div className="col-md-4">
              <Input
                type="text"
                id="suFamilyHead"
                name="suFamilyHead"
                value={values?.suFamilyHead}
                onChange={handleInputChange}
                labelText="Family Head"
              />
            </div> */}

          </div>
          {/* Fourth Row */}
          <div className="row">
            <div className="col-md-12">
              <p><strong>Other Information</strong></p>
            </div>

            <div className="col-md-4">
              <Input
                type="text"
                id="suReferredBY"
                name="suReferredBY"
                value={values?.suReferredBY}
                onChange={handleInputChange}
                labelText="Referred by"
              />
            </div>
            <div className="col-md-4">
              <Input
                type="text"
                id="suEmergencyContact"
                name="suEmergencyContact"
                value={values?.suEmergencyContact}
                onChange={handleInputChange}
                labelText="Emergency Contact No."
                customError={
                  errors.suEmergencyContact && touched.suEmergencyContact
                }
                errorMessage={errors.suEmergencyContact}
                errorClass={
                  errors.suEmergencyContact && touched.suEmergencyContact
                }
              />
            </div>
            <div className="col-md-4">
              <Input
                type="text"
                id="seMedicalAlert"
                name="seMedicalAlert"
                value={values?.seMedicalAlert}
                onChange={handleInputChange}
                labelText="Funding by"
                customError={errors.seMedicalAlert && touched.seMedicalAlert}
                errorMessage={errors.seMedicalAlert}
                erroClass={errors.seMedicalAlert && touched.seMedicalAlert}
              />
            </div>

            <div className="col-md-4">
              <Input
                type="date"
                datePicker={true}
                name="suFirstVisitDate"
                value={values?.suFirstVisitDate}
                selected={
                  values?.suFirstVisitDate &&
                    moment(values.suFirstVisitDate, "YYYY-MM-DD").isValid()
                    ? moment(values.suFirstVisitDate, "YYYY-MM-DD").toDate()
                    : null
                }
                dateFormat="YYYY-MM-DD"
                onChange={(suFirstVisitDate) =>
                  setFieldValue("suFirstVisitDate", moment(suFirstVisitDate).format("YYYY-MM-DD"))
                }
                labelText="First Visit Date"
                placeholderText="Select First Visit Date"
                showYearDropdown={true}
              />

              {/* <Input
                type="date"
                id="suFirstVisitDate"
                name="suFirstVisitDate"
                value={values?.suFirstVisitDate}
                onChange={handleInputChange}
                labelText="First Visit Date"
              /> */}
            </div>
            <div className="col-md-4">
              <Input
                type="date"
                datePicker={true}
                name="suLastVisitDate"
                value={values?.suLastVisitDate}
                selected={
                  values?.suLastVisitDate &&
                    moment(values.suLastVisitDate, "YYYY-MM-DD").isValid()
                    ? moment(values.suLastVisitDate, "YYYY-MM-DD").toDate()
                    : null
                }
                dateFormat="YYYY-MM-DD"
                onChange={(suLastVisitDate) =>
                  setFieldValue("suLastVisitDate", moment(suLastVisitDate).format("YYYY-MM-DD"))
                }
                labelText="Last Visit Date"
                placeholderText="Select Last Visit Date"
                showYearDropdown={true}
              />

              {/* <Input
                type="date"
                id="suLastVisitDate"
                name="suLastVisitDate"
                value={values?.suLastVisitDate}
                onChange={handleInputChange}
                labelText="Last Visit Date"
              /> */}
            </div>

            <div className="col-md-4">
              <Input
                type="text"
                id="providerName"
                name="providerName"
                value={values?.providerName}
                onChange={handleInputChange}
                labelText="Provider"
              />
            </div>

            <div className="col-md-4">
              <div className="form-group">
                <input
                  name="fileName"
                  id="fileName"
                  type="file"
                  accept="video/*,"
                  onChange={handleVideoUpload}
                />
                {
                  videoSizeError ? (
                    <>
                      <div className="validationError">
                        <div className="text-danger">Error: File size exceeds the 5MB limit. Please upload a smaller file.</div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div><p><small>Please upload a file that is 5MB or smaller.</small></p></div>
                    </>
                  )
                }
              </div>
            </div>

            <div className="col-md-12">
              <TextArea
                id="suNote"
                name="suNote"
                value={values?.suNote}
                onChange={handleInputChange}
                labelText="Note"
                rows="3"
              />
            </div>

          </div>


          <footer>
            <div className="formActionButtons">
              <Link
                to="/service-users"
                className="btn btn-sm btn-outline-primary"
              >
                Back
              </Link>
              {isSubmitButtonClicked ? (
                <Button
                  className="btn-sm"
                  variant="primary"
                  disabled
                >
                  Loading...
                </Button>
              ) : (
                <Button className="btn-sm" variant="primary" type="submit">
                  Submit
                </Button>
              )}
            </div>
          </footer>
        </form>
      </div>
      <ToastContainer />
    </>
  );
}

export default InformationForm;
